
import { TranslationService } from "@/core/services/TranslationService";
import { FormatMethods } from "@/helpers/data-format";
import { IForm } from "@/interfaces/iForm";
import { computed, defineComponent, PropType, toRefs } from "vue";
import VZKeyValue from "@/components/content/VZKeyValue.vue";
export default defineComponent({
  name: "form-detail",
  inheritAttrs: false,
  props: {
    data: { type: Object as PropType<IForm>, required: true },
    showCard: { type: Boolean, default: true },
  },
  components: { VZKeyValue },
  setup(props) {
    const { data } = toRefs(props);
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const format = computed(() => {
      return FormatMethods;
    });
    const items = computed(() => {
      return [
        {
          header: t("common.startDate"),
          value: data.value.startDate
            ? format.value.convertUTCToLocalDate(data.value.startDate)
            : "",
        },
        {
          header: t("common.endDate"),
          value: data.value.endDate
            ? format.value.convertUTCToLocalDate(data.value.endDate)
            : "",
        },
        {
          header: t("pages.form.locationRestriction"),
          value: format.value.yesNoToIconPlain(data.value.locationRestrict),
          isHTML: true,
        },
        {
          header: t("pages.form.category"),
          value:
            data.value &&
            data.value.formCategoryModels &&
            data.value.formCategoryModels
              .map((item) => item.categoryCodeText)
              .join(", "),
        },
        {
          header: t("common.status"),
          value: data.value.status
            ? format.value.TitleCase(data.value.status?.toLowerCase())
            : "",
          valueClass:
            data.value.status?.toLowerCase() === "active"
              ? "badge badge-success bg-success"
              : "badge badge-danger bg-danger",
        },
        {
          header: t("common.createdDate"),
          value: data.value.createdDate
            ? format.value.convertUTCToLocalDate(
                data.value.createdDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.createdBy"),
          value: data.value.createdBy,
        },
        {
          header: t("common.updatedDate"),
          value: data.value.updateDate
            ? format.value.convertUTCToLocalDate(
                data.value.updateDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.updatedBy"),
          value: data.value.updatedBy,
        },
      ];
    });

    return {
      t,
      format,
      items,
    };
  },
});
